if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = this.closest(".m-announcement-bar");

      this.handleAnnouncementResize = () => {
        const bar = document.querySelector(".m-announcement-bar");
        const height = bar ? bar.getBoundingClientRect().height : 0;

        document.documentElement.style.setProperty(
          "--m-announcement-height",
          `${height}px`
        );
      };

      this.handleAnnouncementResize();

      if (this.announcementBar && "ResizeObserver" in window) {
        this.announcementResizeObserver = new ResizeObserver(
          this.handleAnnouncementResize
        );
        this.announcementResizeObserver.observe(this.announcementBar);
      }

      window.addEventListener("resize", this.handleAnnouncementResize, {
        passive: true,
      });

      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;

      this.initSlider();
    }

    disconnectedCallback() {
      if (this.announcementResizeObserver) {
        this.announcementResizeObserver.disconnect();
      }

      if (this.handleAnnouncementResize) {
        window.removeEventListener("resize", this.handleAnnouncementResize);
      }

      const bar = document.querySelector(".m-announcement-bar");
      const height = bar ? bar.getBoundingClientRect().height : 0;

      document.documentElement.style.setProperty(
        "--m-announcement-height",
        `${height}px`
      );
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");

      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}